import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import styles from "./sobre_mim_lauraperaroclinic.module.scss";
import InstagramIcon from "../../icons/instagramIcon.tsx";
import MapsIcon from "../../icons/mapsIcon.tsx";
import WhatsappIcon from "../../icons/whatsappIcon.tsx";
import { FaArrowLeft } from "react-icons/fa";

const Sobre_mim_lauraperaroclinic: React.FC = () => {
    const navigate = useNavigate();

    // Estados das modais
    const [showContatos, setShowContatos] = useState(false);
    const [showLocalizacoes, setShowLocalizacoes] = useState(false);

    return (
        <div className={styles.sobre_mim_lauraperaroclinic}>
            {/* HEADER */}
            <div className={styles.header}>
                <Link to="/lauraperaroclinic" className={styles.backButton}>
                    <FaArrowLeft />
                </Link>
                <h1 className="mb-0">Sobre mim</h1>
            </div>

            {/* CONTEÚDO */}
            <div className={styles.content}>
                <div className={styles.imageContainer}>
                    <img
                        src={require("./src/img_sobremim.png")}
                        alt="Laura Peraro"
                    />
                </div>
                <h2>Laura Peraro</h2>
                <p>
                    Fisioterapeuta formada pela UNIRP e pós-graduada em Fisioterapia
                    Dermatofuncional pela FACOP, além de diversas especializações ao
                    longo da carreira.
                </p>
                <p>
                    Minha missão é promover bem-estar, saúde e autoconfiança, unindo
                    conhecimento técnico, sensibilidade e um olhar humanizado para
                    cada paciente.
                </p>
                <p>
                    Acredito que estética vai muito além da aparência — é autocuidado,
                    amor-próprio e transformação de dentro pra fora.
                </p>
                <p>
                    Meu propósito é ajudar cada pessoa a se reconectar com sua melhor
                    versão, resgatando a leveza, a autoestima e o prazer de se sentir
                    bem na própria pele.
                </p>
                <div className={styles.divLogo}>
                    <img
                        className={styles.logoImg}
                        src={require("./src/logo.png")}
                        alt="Logo Laura Peraro Clinic"
                    />
                </div>
            </div>

            {/* FOOTER */}
            <div className={styles.footer}>
                <div className={styles.divSocials}>
                    {/* CONTATOS */}
                    <div onClick={() => setShowContatos(true)} className={styles.socials}>
                        <div className={styles.iconPlaceholder}>
                            <WhatsappIcon height="30" color="#ffffff" />
                        </div>
                        <span>Contatos</span>
                    </div>

                    {/* LOCALIZAÇÕES */}
                    <div onClick={() => setShowLocalizacoes(true)} className={styles.socials}>
                        <div className={styles.iconPlaceholder}>
                            <MapsIcon height="30" color="#ffffff" />
                        </div>
                        <span>Localizações</span>
                    </div>

                    {/* INSTAGRAM */}
                    <a
                        href="https://www.instagram.com/lauraperaroclinic?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                        target="_blank"
                        rel="noreferrer"
                    >
                        <div className={styles.socials}>
                            <div className={styles.iconPlaceholder}>
                                <InstagramIcon height="26" color="#ffffff" />
                            </div>
                            <span>Instagram</span>
                        </div>
                    </a>
                </div>

                <div className={styles.signature}>
                    Desenvolvido por{" "}
                    <a
                        href="https://www.linksvibe.com.br"
                        target="_blank"
                        rel="noreferrer"
                    >
                        Links Vibe
                    </a>
                </div>
            </div>

            {/* === MODAL CONTATOS === */}
            {showContatos && (
                <div className={styles.modalOverlay} onClick={() => setShowContatos(false)}>
                    <div
                        className={styles.modalContent}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            className={styles.closeButton}
                            onClick={() => setShowContatos(false)}
                        >
                            ✕
                        </button>
                        <h2>Contatos</h2>
                        <div className={styles.modalGrid}>
                            <div className={styles.modalCard}>
                                <h3>Barretos - SP</h3>
                                <p>(17) 99633-8485</p>
                                <a
                                    href="https://wa.me/5517996338485?text=Olá, vim pelo link na bio e gostaria de mais informações..."
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <button className={styles.mapButton}>
                                        <WhatsappIcon height="18" color="#fff" />
                                        <span>WhatsApp</span>
                                    </button>
                                </a>
                            </div>
                            <div className={styles.modalCard}>
                                <h3>Guaíra - SP</h3>
                                <p>(17) 98162-2635</p>
                                <a
                                    href="https://wa.me/5517981622635?text=Olá, vim pelo link na bio e gostaria de mais informações..."
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <button className={styles.mapButton}>
                                        <WhatsappIcon height="18" color="#fff" />
                                        <span>WhatsApp</span>
                                    </button>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* === MODAL LOCALIZAÇÕES === */}
            {showLocalizacoes && (
                <div
                    className={styles.modalOverlay}
                    onClick={() => setShowLocalizacoes(false)}
                >
                    <div
                        className={styles.modalContent}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            className={styles.closeButton}
                            onClick={() => setShowLocalizacoes(false)}
                        >
                            ✕
                        </button>
                        <h2>Localizações</h2>
                        <div className={styles.modalGrid}>
                            <div className={styles.modalCard}>
                                <h3>Barretos - SP</h3>
                                <p>Rua Argentina 1560 - Sala 42</p>
                                <a
                                    href="https://maps.app.goo.gl/YBGJPkHGMCZUHte89"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <button className={styles.mapButton}>
                                        <MapsIcon height="18" color="#fff" />
                                        <span>Ver no mapa</span>
                                    </button>
                                </a>
                            </div>
                            <div className={styles.modalCard}>
                                <h3>Guaíra - SP</h3>
                                <p>Rua 20, 020 - Centro</p>
                                <a
                                    href="https://maps.app.goo.gl/ms18kNAfBJ1bQRvw6"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <button className={styles.mapButton}>
                                        <MapsIcon height="18" color="#fff" />
                                        <span>Ver no mapa</span>
                                    </button>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Sobre_mim_lauraperaroclinic;
